import { Thermo } from '@ts/components/Thermo';

export const init = () => {
    setThermo();
}

const setThermo = () => {
    const stepThermometer = Thermo.create(".thermo");
}